import React from "react";
// React Table
import { Container, Row, Col, Table } from "react-bootstrap";
// Styled Components
import styled from "styled-components";

const CustomTd = styled.td`
  background-color: #eeeeee;
`;

const VistaEspiritualidad = ({ datosMisionObra }) => {
  return (
    <Container>
      <Row>
        <Col>
          <Table bordered responsive>
            <tbody>
              <tr>
                <CustomTd className={"w-50"}>
                  <span>Número medio de personas en la obra</span>
                </CustomTd>
                <td>{datosMisionObra?.averageNumber || <small>No especificado</small>}</td>
              </tr>

              <tr>
                <CustomTd className={"w-50"}>
                  <span>Número de personas atendidas anualmente</span>
                </CustomTd>
                <td>{datosMisionObra?.totalNumber || <small>No especificado</small>}</td>
              </tr>
            </tbody>
          </Table>
        </Col>
      </Row>
    </Container>
  );
};

export default VistaEspiritualidad;
